module.exports = __webpack_public_path__ + "img/return_.44150b62.png";